export const getLastPseudonymId = state => state.pseudonym.lastInteractiveId;